"use client";
import Link from "next/link";
import { usePathname } from "next/navigation";

interface NavItem {
  label: string;
  href: string;
}

interface NavLinkProps {
  item: NavItem;
  styling?: {
    allCaps?: boolean;
    fontWeight?: string;
    letterSpacing?: string;
    activeClass?: string;
  };
  onClick?: () => void;
  className?: string;
}

export function NavLink({ item, styling, onClick, className }: NavLinkProps) {
  const pathname = usePathname();
  const isActive =
    pathname === item.href || pathname.startsWith(`${item.href}/`);

  const baseClasses =
    "transition-colors text-sm md:text-base font-body";
  const colorClasses = isActive
    ? styling?.activeClass ?? "text-primary"
    : "text-foreground hover:text-primary";
  const stylingClasses = [
    styling?.fontWeight || "font-medium",
    styling?.letterSpacing || "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Link
      href={item.href}
      onClick={onClick}
      className={`${baseClasses} ${colorClasses} ${stylingClasses} ${className ?? ""}`}
    >
      {styling?.allCaps ? item.label.toUpperCase() : item.label}
    </Link>
  );
}
